<!-- 口袋精灵 -->
<template>
  <div class="container">
    <div class="helper-list">
      <template v-for="(item, index) in list">
        <div class="help-item" :key="item.text">
          <div class="text-box" v-if="item.text">
            <div class="no">
              <div class="no-pic">{{index + 1}}</div>
            </div>
            <div class="text">{{item.text}}</div>
          </div>
          <img class="pic" :src="item.img" v-if="item.img" >
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  components: {  },
  data() {
    return {
      list: [
        {
          text: '先确认智能电视或互联网盒子支持DLNA或AirPlay（咨询厂商或查找说明书）。',
          img: require('@/assets/projectionHelper/p1.png'),
        },
        {
          text: '将智能电视或互联网盒子与手机连接到同一无线网络中。',
          img: require('@/assets/projectionHelper/p2.png'),
        },
        {
          text: '点击视频播放器【投屏】按钮，选择要投屏的设备。',
          img: require('@/assets/projectionHelper/p3.png'),
        },
        {
          text: '投屏成功后，可以用电视遥控器来控制播放进度、音量等。',
        }
      ],
    }
  },
}
</script>

<style scoped lang="less">
.container {
  padding: 14px 0 131px 0;
}
.helper-list {
  .help-item {
    &:not(:first-child) {
      margin-top: 54px;
    }
    .text-box {
      display: flex;
      margin-bottom: 8px;
      padding: 0 19px 0 23px;
      .no {
        flex-shrink: 0;
        &-pic {
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          background: #feb800;
          border-radius: 50%;
          color: #fff;
          font-size: 12px;
        }
      }
      .text {
        flex: 1;
        margin-left: 8px;
        font-size: 17px;
        font-weight: bold;
        color: #2c2a40;
      }
    }
    .pic {
      width: 375px;
    }
  }
}
</style>
